export default __webpack_public_path__ + "static/media/Boots of Reckless Challenge.cc28c6dc.jpg";